// extracted by mini-css-extract-plugin
module.exports = {"header":"JbFnx","logo":"nb7WK","nav-item":"SbHxL"};